import { ReactComponent as Location } from './icon.svg'

export default Location
